import { loginWithOAuth } from '@adornis/authentication/oauth-client/client/loginWithOAuth.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import '@adornis/chemistry/elements/components/x-loader.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { routingState } from '@adornis/router/client/routing-state.js';
import { html, type PropertyValueMap } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../design/components/cr-button.js';
import '../design/components/cr-card.js';
import '../design/components/cr-flex.js';
import '../design/components/cr-image.js';
import '../design/components/cr-link.js';
import '../design/components/cr-progress-bar.js';
import '../design/components/fonts.js';

/**
 * Render this component in your outer most authentication guard. It shows a loader and does a silent login via oauth
 * @customElement chancen-component-login-redirect
 */
@customElement('chancen-component-login-redirect')
export class ChancenComponentLoginRedirect extends ChemistryLitElement {
  @state() private readonly logout = new RXController(this, routingState.searchParams.get('logout'));

  @state() private _wrongState = false;

  override styles() {
    return [
      {
        ':host': {
          height: '100%',
          width: '100%',
        },
      },
    ];
  }

  protected override firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.firstUpdated(_changedProperties);

    // For a short while we could have a logged out user in the logout process, while still on the side. In this case we want to wait until the page redirects to the netz.
    if (this.logout.value) {
      console.info('(OAuth) Loggin out of service.');

      // If something breaks, we give the user a fallback so he can force reload the page. Should never happen unless some server shenanigans happend.
      setTimeout(() => {
        this._wrongState = true;
      }, 3000);
      return;
    } else {
      loginWithOAuth({ silent: true });
    }
  }

  override render() {
    if (this._wrongState) {
      return html`
        <cr-flex w100 h100 center crossaxis-center space="md">
          <cr-text> Hier scheint irgendetwas nicht zu stimmen. </cr-text>
          <cr-button
            @click=${() => {
              const url = new URL(window.location.toString());
              goTo(url.protocol + '//' + url.host + url.pathname, { target: '_parent' });
            }}
          >
            Neu laden!
          </cr-button>
        </cr-flex>
      `;
    }

    return html`
      <cr-flex w100 h100 center crossaxis-center space="lg">
        <cr-loader></cr-loader>
        <cr-text>
          ${!this.logout.value
            ? 'Hallo. Wir melden dich kurz an. 😊'
            : 'Auf Wiedersehen. Du wirst gerade abgemeldet. 🙃'}
        </cr-text>
      </cr-flex>
    `;
  }
}
